export const desktopL = 1500;
export const desktop = 1500;
export const laptop = 1280;
export const laptopS = 1024;
export const tablet = 768;
export const mobileL = 480;
export const mobileM = 375;
export const mobileS = 320;
export const mobileXS = 280;
export const xs = 0;

export const breakpoints = {
  desktopL,
  desktop,
  laptop,
  laptopS,
  tablet,
  mobileL,
  mobileM,
  mobileS,
  mobileXS,
  xs,
};
